import type { Locale } from "../types/locale";

export const LOCALE_STORAGE_KEY = "landing-page-locale";

export function isSupportedLocale(value: string | null | undefined): value is Locale {
  return value === "en" || value === "fil";
}

export function getSavedLocale(): Locale | null {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const savedLocale = window.localStorage.getItem(LOCALE_STORAGE_KEY);
    return isSupportedLocale(savedLocale) ? savedLocale : null;
  } catch {
    return null;
  }
}

export function detectBrowserLocale(): Locale {
  if (typeof navigator === "undefined") {
    return "en";
  }

  try {
    const primaryBrowserLocale =
      (Array.isArray(navigator.languages) && navigator.languages[0]) ||
      navigator.language;

    if (!primaryBrowserLocale) {
      return "en";
    }

    const normalizedCandidate = primaryBrowserLocale.toLowerCase();

    if (
      normalizedCandidate === "fil" ||
      normalizedCandidate.startsWith("fil-") ||
      normalizedCandidate === "tl" ||
      normalizedCandidate.startsWith("tl-")
    ) {
      return "fil";
    }

    if (
      normalizedCandidate === "en" ||
      normalizedCandidate.startsWith("en-")
    ) {
      return "en";
    }
  } catch {
    return "en";
  }

  return "en";
}

export function getInitialLocale(): Locale {
  return getSavedLocale() ?? detectBrowserLocale();
}

export function persistLocale(locale: Locale): void {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    // Ignore storage failures and keep the in-memory locale.
  }
}
